/**
 * @module ol/source/common
 */
/**
 * Default WMS version.
 * @type {string}
 */
export var DEFAULT_WMS_VERSION = '1.3.0';
/**
 * Context options to disable image smoothing.
 * @type {Object}
 */
export var IMAGE_SMOOTHING_DISABLED = {
    imageSmoothingEnabled: false,
    msImageSmoothingEnabled: false,
};
//# sourceMappingURL=common.js.map